var LOADING_ICON = 'Loading';

export { LOADING_ICON };
//# sourceMappingURL=Icon.constants.js.map
